/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './document.defs.js'
export { main as default } from './document.defs.js'
